import { render, staticRenderFns } from "./addEditWorkflow.vue?vue&type=template&id=fbb129f4&scoped=true"
import script from "./addEditWorkflow.vue?vue&type=script&lang=js"
export * from "./addEditWorkflow.vue?vue&type=script&lang=js"
import style0 from "./addEditWorkflow.vue?vue&type=style&index=0&id=fbb129f4&prod&lang=scss&scoped=true"
import style1 from "./addEditWorkflow.vue?vue&type=style&index=1&id=fbb129f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb129f4",
  null
  
)

export default component.exports